import React, { useState } from 'react';
import Joi from 'joi';
import { useDispatch } from 'react-redux';
import { useFieldset } from 'controls/hooks';
import { addEmailToFreeTrialList } from 'actions/freeTrial';
import { Container } from 'components/layout/Container';
import { Input } from 'components/atoms/Input/Input';
import { Button } from 'components/atoms/Button/Button';

import './FreeTrial.scss';

const FreeTrialForm = { email: '' };
const FreeTrialSchema = { email: Joi.string().max(50).required().label('email') };

const FreeTrial = () => {
  const dispatch = useDispatch();
  const [hasSubmittedForm, setHasSubmittedForm] = useState(false);

  const handleSubmit = async (data) => {
    const res = await dispatch(addEmailToFreeTrialList(data));
    if (res) {
      setHasSubmittedForm(true);
    }
  };

  const { fields: { email }, submit, loading } = useFieldset({
    schema: FreeTrialSchema,
    source: FreeTrialForm,
    onSubmit: handleSubmit,
  });

  return (
    <Container>
      {hasSubmittedForm
        ? (
          <>
            <h1 className='freeTrial__title'>Thank you for registering for your free trial!</h1>
            <p className='freeTrial__text'>You will receive an invitation email shortly</p>
          </>
        )
        : (
          <>
            <h1 className='freeTrial__title'>Enter your e-mail to receive your free trial invitation</h1>
            <form onSubmit={submit} className='freeTrial__form'>
              <Input
                field={email}
                placeholder='E-mail address'
                classes='input freeTrial__input'
                type='email'
              />
              <div className='freeTrial__button'>
                <Button
                  loading={loading}
                  text='Submit'
                  type='submit'
                />
              </div>
              <p className='freeTrial__text'>This offer is only valid for NAMM 2022 attendees</p>
            </form>
          </>
        )}
    </Container>
  );
};

export default FreeTrial;
